var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-content"},_vm._l((_vm.data),function(item,key){return _c('div',{key:key,staticClass:"tab-pane fade in",class:{ 'active': _vm.currentTab === item.id },attrs:{"id":("tab-" + (item.id))}},[_c('div',{staticClass:"panel-body",domProps:{"innerHTML":_vm._s(item.content)}})])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f848d50c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/premium/components/TabContent.vue
// module id = null
// module chunks = 